"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
var react_component_lib_1 = require("./react-component-lib");
var loader_1 = require("@diligentcorp/atlas/loader");
loader_1.applyPolyfills().then(function () { loader_1.defineCustomElements(window); });
exports.AtlasAccordion = react_component_lib_1.createReactComponent('atlas-accordion');
exports.AtlasBookshelf = react_component_lib_1.createReactComponent('atlas-bookshelf');
exports.AtlasButton = react_component_lib_1.createReactComponent('atlas-button');
exports.AtlasCheckbox = react_component_lib_1.createReactComponent('atlas-checkbox');
exports.AtlasChip = react_component_lib_1.createReactComponent('atlas-chip');
exports.AtlasColors = react_component_lib_1.createReactComponent('atlas-colors');
exports.AtlasDropdown = react_component_lib_1.createReactComponent('atlas-dropdown');
exports.AtlasDropdownOption = react_component_lib_1.createReactComponent('atlas-dropdown-option');
exports.AtlasHeader = react_component_lib_1.createReactComponent('atlas-header');
exports.AtlasIcon = react_component_lib_1.createReactComponent('atlas-icon');
exports.AtlasIcons = react_component_lib_1.createReactComponent('atlas-icons');
exports.AtlasInput = react_component_lib_1.createReactComponent('atlas-input');
exports.AtlasInsight = react_component_lib_1.createReactComponent('atlas-insight');
exports.AtlasListModules = react_component_lib_1.createReactComponent('atlas-list-modules');
exports.AtlasModal = react_component_lib_1.createReactComponent('atlas-modal');
exports.AtlasNav = react_component_lib_1.createReactComponent('atlas-nav');
exports.AtlasNavItem = react_component_lib_1.createReactComponent('atlas-nav-item');
exports.AtlasNavTools = react_component_lib_1.createReactComponent('atlas-nav-tools');
exports.AtlasNotification = react_component_lib_1.createReactComponent('atlas-notification');
exports.AtlasRadio = react_component_lib_1.createReactComponent('atlas-radio');
exports.AtlasRadioGroup = react_component_lib_1.createReactComponent('atlas-radio-group');
exports.AtlasSearch = react_component_lib_1.createReactComponent('atlas-search');
exports.AtlasSlider = react_component_lib_1.createReactComponent('atlas-slider');
exports.AtlasStatusTag = react_component_lib_1.createReactComponent('atlas-status-tag');
exports.AtlasTab = react_component_lib_1.createReactComponent('atlas-tab');
exports.AtlasTabs = react_component_lib_1.createReactComponent('atlas-tabs');
exports.AtlasTag = react_component_lib_1.createReactComponent('atlas-tag');
exports.AtlasToggle = react_component_lib_1.createReactComponent('atlas-toggle');
//# sourceMappingURL=components.js.map